export function switchUrls() {
  const isSecondLink: boolean = getParam('sl') === 'true';
  if (isSecondLink) {
    switchToSecondLink();
  }

  const isWordPress: boolean = getParam('wp') === 'true';
  if (isWordPress) {
    switchToAltLinks(isSecondLink);
    switchToAltContent();
  }
}

function switchToSecondLink() {
  const links = document.querySelectorAll('a');
  links.forEach(link => {
    const secondLink = link.getAttribute('data-link2');
    if (secondLink) {
      link.setAttribute('href', secondLink);
    }
  });
}

function switchToAltLinks(isSecondLink: boolean = false) {
  const links = document.querySelectorAll('a');
  links.forEach(link => {
    const altLink = !isSecondLink ? link.getAttribute('data-alt-link1') : link.getAttribute('data-alt-link2');
    if (altLink) {
      link.setAttribute('href', altLink);
    }
  });
}

function switchToAltContent() {
  const elements = document.querySelectorAll('.alt-content');
  elements.forEach(element => {
    const altContent = element.getAttribute('data-alt-content');
    if (altContent) {
      element.innerHTML = altContent;
    }
  });
}

function getParam(param: string) {
  return new URLSearchParams(window.location.search).get(param);
}
